import React, { Component } from "react";
import ListTable from "./ListTable";
import WarehouseMonitoringStore from "../store/WarehouseMonitoringStore";
import {
  Avatar,
  Button,
  Col,
  Dropdown,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
  Image,
} from "antd";
import config from "../config";
import { DownOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { Link } from "react-router-dom";
import MapForVehiclePosition from "./MapForVehiclePosition";

import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class WarehouseMonitoring extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadList: 0,
      companyId: "",
      warehouseId: "",
      vehicleObj: false,
    };
    this.WarehouseMonitoringStore = new WarehouseMonitoringStore();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      console.log("ilocasd");
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }
  async componentDidMount() {
    //    await this.WarehouseMonitoringStore.loadData({
    //       companyId: null,
    //       warehouseId: null,
    //       offset: 0,
    //       limit: 50,
    //     });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.WarehouseMonitoringStore.getWarehouseByCompany({
        companyId: this.props.getUserData().userCompanyId,
      });
      // await this.handleSearch();

      // await this.handleChange();
      await this.setState({ update: 1 });
    }
    setInterval(() => {
      this.WarehouseMonitoringStore.loadData({
        companyId: this.state.companyId,
        warehouseId: this.state.warehouseId,
        offset: 0,
        limit: 50,
      });
    }, 60000);
    this.columns = [
      {
        // title: "Account Name",
        title: this.context.translate(
          "_FLEET_COMPANY_COMPANYLIST_COMPANYNAME_"
        ),
        dataIndex: "companyName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Warehouse Name",
        title: this.context.translate("_WAREHOUSE_NAME_"),
        dataIndex: "warehouse",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "License Number",
        title: this.context.translate("_FLEET_DRIVER_DRIVERLIST_LICENCE_"),
        dataIndex: "licenseNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },

      {
        title: this.context.translate("_INVENTORY_ONE_"),
        dataIndex: "inventory1",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (inventory1) => {
          return <div dangerouslySetInnerHTML={{ __html: inventory1 }} />;
        },
      },
      {
        title: this.context.translate("_INVENTORY_TWO_"),
        dataIndex: "inventory2",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (inventory2) => {
          return <div dangerouslySetInnerHTML={{ __html: inventory2 }} />;
        },
      },
      {
        title: this.context.translate("_INVENTORY_THREE_"),
        dataIndex: "inventory3",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (inventory3) => {
          return <div dangerouslySetInnerHTML={{ __html: inventory3 }} />;
        },
      },
      {
        title: this.context.translate("_INVENTORY_FOUR_"),
        dataIndex: "inventory4",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (inventory4) => {
          return <div dangerouslySetInnerHTML={{ __html: inventory4 }} />;
        },
      },
      {
        title: this.context.translate("_INVENTORY_FIVE_"),
        dataIndex: "inventory5",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (inventory5) => {
          return <div dangerouslySetInnerHTML={{ __html: inventory5 }} />;
        },
      },
      {
        title: this.context.translate("_INVENTORY_SIX_"),
        dataIndex: "inventory6",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (inventory6) => {
          return <div dangerouslySetInnerHTML={{ __html: inventory6 }} />;
        },
      },
      {
        title: this.context.translate("_INVENTORY_SEVEN_"),
        dataIndex: "inventory7",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (inventory7) => {
          return <div dangerouslySetInnerHTML={{ __html: inventory7 }} />;
        },
      },      

      {
        // title: "Address",
        dataIndex: "address",
        title: this.context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (text, obj) => {
          return (
            <Link
              onClick={async () => {
                await this.setState({
                  vehicleObj: { ...obj, icon: "logo_icon.png" },
                  heading: this.context.translate("_LOCATION_ON_MAP_"),
                });
                await this.setState({ loadData: 1 });
              }}
            >
              {text}
            </Link>
          );
        },
      },
    ];

    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Avatar
                style={{ height: "12px", width: "12px", borderRadius: "0px" }}
                src={Excel}
              ></Avatar>
              {this.context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Avatar
                style={{ height: "12px", width: "12px", borderRadius: "0px" }}
                src={PDF}
              ></Avatar>
              {this.context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        const result = [];

        var getData = {
          cid: this.state.companyId,
          warehouseId: this.state.warehouseId,
        };
        console.log(getData);
        if (val.key == "excel") {
          this.WarehouseMonitoringStore.exportExcel(getData);
        }
        if (val.key == "pdf") {
          this.WarehouseMonitoringStore.exportPdf(getData);
        }
      },
    };
    await this.setState({ update: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  handleChange = async (val) => {
    // console.log(val.comp.value,comp)
    this.WarehouseMonitoringStore.loadData({
      companyId: val.comp.value,
      warehouseId: this.state.warehouseId,
      offset: 0,
      limit: 50,
    });
    await this.setState({ warehouseId: " " });
    // this.WarehouseMonitoringStore.CompanyWiseWarehouseData = []
    await this.WarehouseMonitoringStore.getWarehouseByCompany({
      companyId: val.comp.value,
    });
    await this.setState({ companyId: val.comp.value });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.WarehouseMonitoringStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <div>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  allowClear={true}
                  onChange={(comp) => this.handleChange({ comp })}
                  style={{ width: 200 }}
                />

                <Select
                  style={{
                    width: 170,
                  }}
                  className="searchInput"
                  fieldNames={{ label: "warehouse", value: "id" }}
                  //   value={
                  //     this.state.distCompanyId ? this.state.distCompanyId : null
                  //   }
                  // placeholder="Warehouse"
                  placeholder={this.context.translate("_WAREHOUSE_")}
                  onSelect={async (warehouseId) => {
                    await this.WarehouseMonitoringStore.loadData({
                      companyId: this.state.companyId,
                      warehouseId: warehouseId,
                      offset: 0,
                      limit: 50,
                    });
                    await this.setState({ warehouseId });
                  }}
                  optionFilterProp="children"
                  options={
                    this.WarehouseMonitoringStore?.CompanyWiseWarehouseData
                  }
                />
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "30px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              <Tooltip
                title={this.context.translate("_DOWNLOAD_")}
                placement="bottom"
              >
                <span>
                  <Button
                    className="downloadExcelButton"
                    disabled={
                      this.WarehouseMonitoringStore?.warehouseData?.length > 0
                        ? false
                        : true
                    }
                  >
                    <Dropdown
                      overlayClassName="export-dropdown"
                      menu={this.ExportMenuProps}
                    >
                      <Image
                        style={{
                          height: 18,
                          alignItems: "center",
                          marginInlineEnd: "30px",
                        }}
                        src={downloadIcon}
                      ></Image>
                    </Dropdown>
                  </Button>
                </span>
              </Tooltip>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.WarehouseMonitoringStore?.total}
            columns={this.columns}
            dataSource={this.WarehouseMonitoringStore?.warehouseData}
            loading={this.WarehouseMonitoringStore.loading}
            onChange={this.handleTableChange}
            pagination={{ currentPage: this.state.currentPage }}
          />
        </div>
        {this.state.vehicleObj && (
          <MapForVehiclePosition
            vehicleObj={this.state.vehicleObj}
            heading={this.state.heading}
            closeMapModal={(resp) => {
              this.setState({ vehicleObj: resp });
            }}
          />
        )}
      </div>
    );
  }
}
WarehouseMonitoring.contextType = StoreContext;
export default observer(withRouter(WarehouseMonitoring));
